/* eslint-disable */
import {BhImage} from './BhImage';
import {Ad} from './Ad';
/**
* @description Interface for Avensia.Commerce.Web.Models.Ads.MediumAd
*/
export interface MediumAd extends Ad {
	preTitle: string;
	description: string;
	brandImage: BhImage;
	adImage: BhImage;
	isOnTv: boolean;
	splashTextTop: string;
	splashTextMiddle: string;
	splashTextBottom: string;
	splashTextEnd: string;
	isCampaign: boolean;
	isPartialCampaign: boolean;
	isLowPrice: boolean;
	isBundleSavings: boolean;
	isLoweredPrice: boolean;
	campaignEnd: Date;
}
export const isMediumAd = (model: unknown): model is MediumAd => (model as MediumAd).component === 'Bygghemma.Commerce.Web.Models.Ads.MediumAd';

